import {
	AlarmClock,
	AlertTriangle,
	Archive,
	ArrowDown,
	ArrowLeft,
	ArrowRight,
	ArrowUp,
	Banknote,
	BarChart3,
	Bell,
	Bold,
	BookHeart,
	BookImage,
	BookUser,
	Boxes,
	BriefcaseBusiness,
	Building,
	CalendarCheck,
	CalendarDays,
	ChartNoAxesColumnIncreasing,
	ChartNoAxesCombinedIcon,
	Check,
	CheckCheck,
	CheckSquare,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronsLeft,
	ChevronsRight,
	ChevronsUpDown,
	ChevronUp,
	Circle,
	CircleCheck,
	CircleCheckBig,
	CircleHelp,
	CircleUser,
	CircleX,
	Clipboard,
	Clock,
	Columns3Cog,
	Copy,
	CreditCard,
	Crop,
	Database,
	DollarSign,
	Download,
	Edit,
	EllipsisVertical,
	Eye,
	EyeOff,
	File,
	FileDown,
	FileSliders,
	FileSpreadsheet,
	FileTerminal,
	FileText,
	FileUser,
	Filter,
	Folder,
	FolderArchive,
	FolderCog,
	FolderKanban,
	Footprints,
	GitBranch,
	Grid,
	HardHat,
	Heart,
	History,
	House,
	Image,
	Inbox,
	Info,
	Italic,
	Link,
	List,
	ListChecks,
	ListFilter,
	Loader,
	Loader2,
	LoaderCircle,
	Lock,
	LockOpen,
	LogIn,
	LogOut,
	Mail,
	MapPin,
	Mars,
	Menu,
	MessageSquare,
	MessageSquareMore,
	Minus,
	MinusCircle,
	Moon,
	MoreHorizontal,
	MoreVertical,
	NotebookTabs,
	Octagon,
	OctagonAlert,
	Package,
	PanelLeft,
	Pause,
	Phone,
	Play,
	Plus,
	PlusCircle,
	Power,
	Recycle,
	RefreshCw,
	RotateCcw,
	Save,
	ScanQrCode,
	Scroll,
	ScrollText,
	Search,
	Send,
	Settings,
	Share2,
	Shield,
	Shirt,
	ShoppingBag,
	ShoppingCart,
	Shuffle,
	Sliders,
	SquarePlay,
	SlidersHorizontal,
	Star,
	SunMedium,
	ThumbsDown,
	ThumbsUp,
	Trash,
	TrendingDown,
	TrendingUp,
	Truck,
	Twitter,
	Underline,
	Upload,
	UploadCloud,
	User,
	UserRound,
	Users,
	UsersRound,
	Venus,
	VenusAndMars,
	Volume2,
	VolumeX,
	Wallet,
	X,
	Headset,
	FileBox,
	type LucideProps,
	CircleAlert,
	TriangleAlert,
	UserLock,
	UserRoundCog,
	Pencil,
	Building2,
	Network,
	Crown,
	Bot,
	ExternalLink,
	PhoneCall,
} from 'lucide-react';
export const Icons = {
	headset: Headset,
	fileBox: FileBox,
	package: Package,
	house: House,
	crown: Crown,
	alertCircle: CircleAlert,
	alertTriangle: TriangleAlert,
	fileSpreadsheet: FileSpreadsheet,
	trendingUp: TrendingUp,
	trendingDown: TrendingDown,
	bookHeart: BookHeart,
	scrollText: ScrollText,
	bell: Bell,
	scroll: Scroll,
	bold: Bold,
	italic: Italic,
	network: Network,
	underline: Underline,
	boxes: Boxes,
	recycle: Recycle,
	shuffle: Shuffle,
	listCheck: ListChecks,
	listFilter: ListFilter,
	doubleCheck: CheckCheck,
	rotateCcw: RotateCcw,
	phone: Phone,
	save: Save,
	lock: Lock,
	unlock: LockOpen,
	lockOpen: LockOpen,
	triangle: AlertTriangle,
	excel: FileSpreadsheet,
	moreHorizontal: MoreHorizontal,
	image: Image,
	power: Power,
	columns3Cog: Columns3Cog,
	ellipsisVertical: EllipsisVertical,
	circleCheck: CircleCheck,
	fileText: FileText,
	loader: Loader,
	loaderCircle: LoaderCircle,
	folder: Folder,
	folderArchive: FolderArchive,
	folderKanban: FolderKanban,
	folderConfig: FolderCog,
	chartCol: ChartNoAxesColumnIncreasing,
	chartCombined: ChartNoAxesCombinedIcon,
	bookUser: BookUser,
	octagon: Octagon,
	octagonAlert: OctagonAlert,
	bookImage: BookImage,
	usersRounded: UsersRound,
	userRounded: UserRound,
	banknote: Banknote,
	circleUser: CircleUser,
	fileUser: FileUser,
	clipboardList: Clipboard,
	notebookTabs: NotebookTabs,
	sun: SunMedium,
	moon: Moon,
	star: Star,
	panelLeft: PanelLeft,
	twitter: Twitter,
	close: X,
	closeCircle: CircleX,
	spinner: Loader2,
	packageBox: Package,
	eye: Eye,
	eyeOff: EyeOff,
	list: List,
	database: Database,
	inbox: Inbox,
	archive: Archive,
	chevronLeft: ChevronLeft,
	chevronRight: ChevronRight,
	chevronsLeft: ChevronsLeft,
	chevronsRight: ChevronsRight,
	chevronUp: ChevronUp,
	chevronDown: ChevronDown,
	chevronUpDown: ChevronsUpDown,
	arrowUp: ArrowUp,
	arrowDown: ArrowDown,
	arrowLeft: ArrowLeft,
	arrowRight: ArrowRight,
	menu: Menu,
	venusAndMars: VenusAndMars,
	venus: Venus,
	mars: Mars,
	heart: Heart,
	mail: Mail,
	building: Building,
	building2: Building2,
	verticalThreeDots: MoreVertical,
	horizontalThreeDots: MoreHorizontal,
	verticalSliders: Sliders,
	horizontalSliders: SlidersHorizontal,
	history: History,
	circle: Circle,
	circleCheckBig: CircleCheckBig,
	clipboard: Clipboard,
	circleHelp: CircleHelp,
	check: Check,
	checkSquare: CheckSquare,
	add: Plus,
	addCircle: PlusCircle,
	scanQrCode: ScanQrCode,
	remove: Minus,
	minusCircle: MinusCircle,
	view: Eye,
	hide: EyeOff,
	trash: Trash,
	edit: Edit,
	pencil: Pencil,
	more_vertical: MoreVertical,
	crop: Crop,
	reset: RefreshCw,
	send: Send,
	youtube: SquarePlay,
	copy: Copy,
	link: Link,
	gitBranch: GitBranch,
	tool: FileSliders,
	download: Download,
	warning: AlertTriangle,
	briefcaseBusiness: BriefcaseBusiness,
	search: Search,
	filter: Filter,
	alarm: AlarmClock,
	calendar: CalendarDays,
	calendarCheck: CalendarCheck,
	user: User,
	userLock: UserLock,
	userRoundCog: UserRoundCog,
	users: Users,
	login: LogIn,
	order: ScrollText,
	terminal: FileTerminal,
	settings: Settings,
	logout: LogOut,
	volume: Volume2,
	volumeMute: VolumeX,
	message: MessageSquare,
	messageMore: MessageSquareMore,
	billing: CreditCard,
	wallet: Wallet,
	dollarSign: DollarSign,
	cart: ShoppingCart,
	shoppingBag: ShoppingBag,
	product: Package,
	store: ShoppingBag,
	chart: BarChart3,
	upload: Upload,
	info: Info,
	thumbUp: ThumbsUp,
	thumbDown: ThumbsDown,
	uploadClound: UploadCloud,
	placeholder: Image,
	clothing: Shirt,
	shoes: Footprints,
	accessories: HardHat,
	pause: Pause,
	play: Play,
	truck: Truck,
	creditCard: CreditCard,
	mapPin: MapPin,
	shield: Shield,
	clock: Clock,
	refresh: RefreshCw,
	file: File,
	fileDown: FileDown,
	share: Share2,
	grid: Grid,
	// phone: Phone,
	phoneCall: PhoneCall,
	externalLink: ExternalLink,
	bot: Bot,

	emptyData: ({ ...props }: LucideProps) => (
		<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M17 6.33228L9 16.9989V54.3323C9 55.7468 9.5619 57.1033 10.5621 58.1035C11.5623 59.1037 12.9188 59.6656 14.3333 59.6656H51.6667C53.0811 59.6656 54.4377 59.1037 55.4379 58.1035C56.4381 57.1033 57 55.7468 57 54.3323V16.9989L49 6.33228H17Z" />
			<path d="M9 16.9999H57" />
			<path d="M43.6663 27.6677C43.6663 30.4967 42.5425 33.2098 40.5421 35.2102C38.5418 37.2106 35.8286 38.3344 32.9997 38.3344C30.1707 38.3344 27.4576 37.2106 25.4572 35.2102C23.4568 33.2098 22.333 30.4967 22.333 27.6677" />
		</svg>
	),
};
